// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 9779 ? "d2d722bc" : chunkId) + "." + {"1766":"7aa1fffefbb1df8b","5711":"03a40cfe8636515e","9779":"22f75e81f9fcbde1"}[chunkId] + ".js";
};